// import image from '../assets/potrait.png'

// web images
import lakshitaImg from '../assets/cocom-images/lakshitaa-lakshitaa.jpg'
import divyImg from '../assets/cocom-images/divy_arun_mav-divyarunmav.png'
import vedantImg from '../assets/cocom-images/vedant_naik-vedantnaik.jpg'
import arnavImg from '../assets/cocom-images/arnav_deo-arnavdeo.png'
import rajvardhanImg from '../assets/cocom-images/rajvardhanImg.jpg'
// pubs image
import rasikaImg from '../assets/cocom-images/rasika-rasikaadiseshan.jpeg'
import nikitaImg from '../assets/cocom-images/gdsc_nitikajain-nitikajain.jpg'
import umangImg from '../assets/cocom-images/umang.gdsc_djsce.jpg-umangduwani.heic'
import delaineImg from '../assets/cocom-images/delanie-gdsc-delanierodrigues.jpeg'
import smitImg from '../assets/cocom-images/smit_pubs-smitpatel.jpg'

// ml images
import deepImg from '../assets/cocom-images/deep-deeppandharkar.jpg'
import rishiImg from '../assets/cocom-images/rishi_punmiya-rishipunmiya.heic'
import aditiImg from '../assets/cocom-images/aditi-aditigaikwad.jpeg'

// creatives image
import sohamImg from '../assets/cocom-images/soham_djsce-sohamlotlikar.jpg'
import yakshImg from '../assets/cocom-images/yakshdarji_creatives-yakshdarji.jpg'
import vatsImg from '../assets/cocom-images/vats_gdsc_djsce-vatss.shah.jpg'
import aryaImg from '../assets/cocom-images/arya_vaidya-aryavaidya.jpg'
import hitanshImg from '../assets/cocom-images/hitanshmehta-hitanshmehta.jpg'
import riyaImg from '../assets/cocom-images/riyagala_gdsc-e_14_riya_gala.jpg'
import meenakshiImg from '../assets/cocom-images/gdsc_djsce-meenakshichandra.jpg'
import ridayImg from '../assets/cocom-images/riday_gada-ridaygada.jpg'
import jiteshImg from '../assets/cocom-images/jitesh_img-jiteshguria.jpg'

// app images
import vipulImg from '../assets/cocom-images/pxl_20230429_072914684-vipulgupta.jpg'
import sauravImg from '../assets/cocom-images/sauravhaldar-sauravhaldar.png'
import meetImg from '../assets/cocom-images/meet_chavan-meetchavan.jpg'
import varshaImg from '../assets/cocom-images/varshaislur-pundalikislur.jpg'
import ojasImg from '../assets/cocom-images/ojas.jpg-ojasgeet.jpg'

// marketing images
import praveshImg from '../assets/cocom-images/pravesh_dagade-praveshdagade.jpg'
import uthkrushtaImg from '../assets/cocom-images/uthkrushta-gdsc_djsce-uthkrushtamathur.jpg'
import yashMadImg from '../assets/cocom-images/yash_madhani-yashmadhani.jpg'
import harshilImg from '../assets/cocom-images/gdsc_harshilkhara-harshilkhara.jpg'
import yashviImg from '../assets/cocom-images/img_20231127_165341-yashvisoni.jpg'
import pulkitImg from '../assets/cocom-images/pulkittodi_gdsc_djsce-pulkittodi.jpg'
import shantanuImg from '../assets/cocom-images/shantanu-660shantanudhar.jpg'
import kisnaImg from '../assets/cocom-images/kisnashah-kisnashah.jpg'
import krishImg from '../assets/cocom-images/krishgdsc_djsce-krishjain.jpg'

// logistice images
import darshanImg from '../assets/cocom-images/darshandihora-darshandihora.jpeg'
import aneeshImg from '../assets/cocom-images/gdsc_aneesh-aneeshjoshi.jpg'
import ishikaImg from '../assets/cocom-images/ishikarampariya-ishikarampariya.jpeg'
import siddhanthImg from '../assets/cocom-images/siddhanthnaik_djsce_gdsc-siddhanthnaik.jpg'
import agamImg from '../assets/cocom-images/agam__djsce-agamkamdar.jpeg'

const cocomData = {
    logistics: [
        {
            'id': 0,
            image: darshanImg,
            'name': 'Darshan Dihora',
            'description': 'leveraging success',
            'instagram': 'https://instagram.com/darshan.dihora?igshid=NzZlODBkYWE4Ng%3D%3D&utm_source=qr',
            'linkedIn': 'https://www.linkedin.com/in/darshan-dihora-38bb652a1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app', 'github': 'nan',
        },
        {
            image: aneeshImg,
            'id': 1,
            'name': 'Aneesh Joshi',
            'description': 'I am an ambitious team player who is not afraid to face challenges.',
            'instagram': 'https://www.instagram.com/_aneeeshhhh/',
            'linkedIn': 'https://www.linkedin.com/in/aneesh-joshi-287926289/',
            'github': 'nan',
        },
        {
            'id': 2,
            image: ishikaImg,
            'name': 'Ishika Rampariya',
            'description': "I, dedicate member of logistics department, passionate about optimizing logistics processes, will make sure towards ensuring overall performance & enhancing department's productivity",
            'instagram': 'https://www.instagram.com/invites/contact/?i=1sppn72mc51re&utm_content=i9ok8gt',
            'linkedIn': 'https://www.linkedin.com/in/ishika-rampariya-406361245?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app', 'github': 'nan',
        },
        {
            'id': 3,
            image: siddhanthImg,
            'name': 'Siddhanth Naik',
            'description': 'An avid learner with an analytical mind and\ngood communication skills. Proficient at\nworking effectively with diverse teams', 'instagram': 'https://instagram.com/siddhanth27?igshid=NGVhN2U2NjQ0Yg==',
            'linkedIn': 'linkedin.com/in/siddhanth- naik-b94a24232',
            'github': 'https://github.com/s1ddhanth27',
        },
        {
            'id': 4,
            image: agamImg,
            'name': 'AGAM S KAMDAR',
            'description': '\nCurious mind, passionate learner, and creative thinker with a zest for meaningful connections and growth.',
            'instagram': 'https://instagram.com/agam_kamdar?igshid=YTQwZjQ0NmI0OA==',
            'linkedIn': 'https://www.linkedin.com/in/agam-kamdar-00894325b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app', 'github': 'nan',
        }
    ],
    marketing: [
        {
            'name': 'Pravesh Dagade ',
            image: praveshImg,
            'description': 'Transforming ideas into trends, I specialize in strategic campaigns and data-driven brilliance.',
            'instagram': 'https://instagram.com/praveshdagade?igshid=MzMyNGUyNmU2YQ==',
            'linkedIn': 'https://www.linkedin.com/in/pravesh-dagade-20bab7245?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            'github': 'nan',
            'id': 0
        },
        {
            'name': 'Uthkrushta Mathur ', 'description': "I'm always up for a bit of digital exploration and learning about the world as it evolves.",
            image: uthkrushtaImg,
            'instagram': 'https://instagram.com/greaterlapc?igshid=YTQwZjQ0NmI0OA==',
            'linkedIn': 'https://www.linkedin.com/in/uthkrushta-mathur-927144265/',
            'github': 'nan',
            'id': 1
        },
        {
            'name': 'Yash Madhani',
            image: yashMadImg,
            'description': 'Hard Working Marketing Team Member',
            'instagram': 'https://www.instagram.com/yash_madhani/#',
            'linkedIn': 'www.linkedin.com/in/yashmadhani',
            'github': 'https://github.com/yash-madhani',
            'id': 2
        },
        {
            'name': 'HARSHIL KHARA',
            image: harshilImg,
            'description': "I'm all about embracing the joy in life's simple moments. Join me on this adventure of learning and\xa0connecting!",
            'instagram': 'https://instagram.com/harshil__khara?igshid=MTk0NTkyODZkYg==',
            'linkedIn': 'www.linkedin.com/in/ harshil-khara-58337628a',
            'github': 'nan',
            'id': 3
        },
        {
            'name': 'Yashvi soni ',
            image: yashviImg,
            'description': "I'm immersed in the world of IoT, cybersecurity, and blockchain as a student. Despite being a coding beginner, I'm eager to unravel the complexities of these technologies",
            'instagram': 'https://www.instagram.com/invites/contact/?i=by884tkbk8aq&utm_content=emtnm6k',
            'linkedIn': 'https://www.linkedin.com/in/yashvi-soni-5071aa299?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app', 'github': 'nan',
            'id': 4
        },
        {
            'name': 'PULKIT TODI',
            image: pulkitImg,
            'description': 'I am Passionate about leveraging the art and science of marketing to generate meaningful value. Committed to laying a solid basis for a well-rounded career in the sector.',
            'instagram': 'https://www.instagram.com/pulkit.todi?utm_source=qr',
            'linkedIn': 'https://www.linkedin.com/in/pulkit-todi-7637a4230',
            'github': 'https://github.com/PulkitTodi',
            'id': 5
        },
        {
            'name': 'Shantanu Dhar',
            image: shantanuImg,
            'description': 'Passionate about forging new connections, dedicated to daily self-improvement and a committed team player striving to evolve into a better version of myself each day.',
            'instagram': 'https://www.instagram.com/shantanudharr/',
            'linkedIn': 'https://www.linkedin.com/in/shantanu-dhar-978738257/',
            'github': 'nan',
            'id': 6
        },
        {
            'name': 'Krish D Jain',
            image: krishImg,
            'description': 'Thinking about tagline is not my job, bringing money is.',
            'instagram': 'https://www.instagram.com/23krishjain/',
            'linkedIn': 'https://www.linkedin.com/in/krish-jain-426499227/',
            'github': 'https://github.com/23krishjain',
            'id': 7
        },
        {
            'name': 'Kisna shah ',
            image: kisnaImg,
            'description': 'A tech visionary and event maestro , forging the future of innovation. ',
            'instagram': 'https://instagram.com/ks_shah7',
            'linkedIn': 'https://www.linkedin.com/in/kisna-shah',
            'github': 'nan',
            'id': 8
        }
    ],
    web: [
        {
            id: 1,
            image: lakshitaImg,
            name: 'Lakshitaa Chellaramani',
            description: 'passionate learner and a staunch believer in hard work',
            instagram: 'https://www.instagram.com/lakshitaa.xo/',
            github: 'https://github.com/lakshitaa-chellaramani',
            linkedIn: 'https://www.linkedin.com/in/lakshitaa-chellaramani-68254224b',
        },
        {
            id: 2,
            image: divyImg,
            name: 'Divy Arun Mav',
            description: 'MERN-Stack Developer | Blockchain Enthusiast',
            instagram: 'https://instagram.com/divy_mav?igshid=YTQwZjQ0NmI0OA==',
            github: 'https://github.com/divy-arun-mav',
            linkedIn: 'https://www.linkedin.com/in/divy-mav-7b82b0249?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
        },
        {
            id: 3,
            image: vedantImg,
            name: 'Vedant Naik',
            description: `I'm batman, except he becomes a nerd at night`,
            instagram: 'http://www.instagram.com/vedant.naik09',
            github: 'https://github.com/vedantnaik09',
            linkedIn: 'https://www.linkedin.com/in/vedant-naik-9a77b0b0/',
        },
        {
            id: 4,
            image: arnavImg,
            name: 'Arnav Deo ',
            description: `Full Stack Developer and Budding Engineer!`,
            instagram: 'https://www.instagram.com/arnitdo',
            github: 'https://www.github.com/arnitdo',
            linkedIn: 'https://linkedin.com/in/arnitdo',
        },
        {
            id: 5,
            image: rajvardhanImg,
            name: 'Rajvardhan Singh Chib',
            description: `Artificial Intelligence and data science engineering student.`,
            instagram: 'https://www.instagram.com/rajvardhanxchib',
            github: 'https://github.com/Rajvardhan135',
            linkedIn: 'https://www.linkedin.com/in/rajvardhan-singh-chib-1a328a212/',
        },
    ],
    publicity: [
        {
            id: 1,
            image: rasikaImg,
            name: 'Rasika Adiseshan',
            description: `Enthusiastic learner embracing challenges at the intersection of art and technology.`,
            instagram: 'https://instagram.com/rasika._1908?igshid=MTNiYzNiMzkwZA==',
            github: '',
            linkedIn: 'https://www.linkedin.com/in/rasika-adiseshan-095362275?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
        },
        {
            id: 2,
            image: nikitaImg,
            name: 'Nitika Jain',
            description: `Romanising life by clicking pictures of the sky and my favourite people and being delusional `,
            instagram: 'https://instagram.com/_nitikx_?igshid=YTQwZjQ0NmI0OA==',
            github: '',
            linkedIn: 'https://www.linkedin.com/in/nitikajain012',
        },
        {
            id: 3,
            image: umangImg,
            name: 'Umang Duwani',
            description: `I am exploring this my technical field being far from home,so this journey is tough but also full of excitement and challenges for me.`,
            instagram: 'https://instagram.com/umang__duwani?igshid=NzZlODBkYWE4Ng%3D%3D&utm_source=qr',
            github: '',
            linkedIn: 'https://www.linkedin.com/in/umang-duwani-10a430281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
        },
        {
            id: 4,
            image: delaineImg,
            name: 'Delanie Rodrigues',
            description: `Passionate learner, driven by ambition and a competitive spirit. I enjoy leading and working with others to make things happen .Using my determination to make a difference.`,
            instagram: 'https://www.instagram.com/delanie_rodrigues/',
            github: '',
            linkedIn: 'https://www.linkedin.com/in/delanie-rodrigues-374793251',
        },
        {
            id: 5,
            image: smitImg,
            name: 'Smit Manojkumar Patel',
            description: `Here to connect and learn.`,
            instagram: 'https://instagram.com/smitpatel.04?utm_source=qr',
            github: '',
            linkedIn: 'https://www.linkedin.com/in/smit-patel-7401192a2?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
        },

    ],
    ml: [
        {
            id: 0,
            image: deepImg,
            name: 'Deep Pandharkar',
            description: 'My eyes on the Opportunity, My Mind on the Money and My roots in the Community',
            'instagram': 'https://www.instagram.com/pandharkardeep/',
            'linkedIn': 'https://www.linkedin.com/in/pandharkardeep/',
            'github': 'https://github.com/pandharkardeep',
        },
        {
            'id': 1,
            // image: image,
            'name': 'Dipti Agarwal ',
            description: "We Scholar'23 |#include <her>'4.0 | IT'26",
            'instagram': 'https://instagram.com/diptiagarwal2004?igshid=MTNiYzNiMzkwZA==',
            'linkedIn': 'https://www.linkedin.com/in/diptiagarwal2004?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            'github': 'https://github.com/DiptiAgarwal2004',
        },
        {
            'name': 'Rishi Punmiya',
            image: rishiImg,
            description: 'Creative and Result Oriented ',
            'instagram': 'https://instagram.com/rishipunmiya09?igshid=NzZlODBkYWE4Ng%3D%3D&utm_source=qr',
            'linkedIn': 'https://www.linkedin.com/in/rishi-punmiya-288b6b2a1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            'github': 'https://github.com/rishipunmiya',
            'id': 2
        },
        {
            'name': 'Aditi Gaikwad',
            image: aditiImg,
            description: 'Tech enthusiast ',
            'instagram': 'https://www.instagram.com/uyaditi_/',
            'linkedIn': 'https://www.linkedin.com/in/aditig06/',
            'github': 'https://github.com/uyaditi', 'id': 3
        }
    ],

    creatives: [
        {
            'id': 0,
            image: sohamImg,
            'name': 'Soham Patil',
            'description': 'A versatile creative blending video editing, visual art, coding, and generative design to craft immersive experiences.',
            'instagram': 'https://www.instagram.com/sohvm774/',
            'linkedIn': 'https://www.linkedin.com/in/soham-patil-a73ba3294/',
            'github': 'https://github.com/Sohamiscurious',
        },
        {
            'id': 1,
            image: yakshImg,
            'name': 'Yaksh Darji ',
            'description': 'Digital architects, turning ideas into pixels with lines of code.',
            'instagram': 'https://instagram.com/_yaksh_._?igshid=MzMyNGUyNmU2YQ==',
            'linkedIn': 'https://www.linkedin.com/in/yaksh-darji-2296a9222?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            'github': 'https://github.com/dyaksh',
        },
        {
            'id': 2,
            image: vatsImg,
            'name': 'Vats S. Shah',
            'description': 'From writing books, hosting his own podcast to creating programs he has done it all. Vats is one of the key members of the creatives dept where he has delivered exceptional ideas and solutions ',
            'instagram': 'https://www.instagram.com/vatssshah/',
            'linkedIn': 'https://www.linkedin.com/in/vats-shah-9842861a7/',
            'github': 'https://github.com/VatsSShah',
        },
        {
            'id': 3,
            image: aryaImg,
            'name': 'Arya Vaidya',
            'description': 'Creative at heart, I find my inspiration in the rhythm of music and the pages of a good book. More of a small-circle person, I enjoy meaningful connections and quiet moments.',
            'instagram': 'https://www.instagram.com/_.aryaaaa._.59?utm_source=qr',
            'linkedIn': 'https://www.linkedin.com/in/arya-vaidya-1a9b28257?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app ',
            'github': 'nan',
        },
        {
            'id': 4,
            image: hitanshImg,
            'name': 'Hitansh Mehta',
            'description': 'PartTime Code Whisperer: Turning coffee into algorithms and bugs into features since yesterday....',
            'instagram': 'https://www.instagram.com/_hitansh_m/',
            'linkedIn': 'www.linkedin.com/in/hitansh-m',
            'github': 'https://github.com/HitanshMehta',
        },
        // {
        //     'id': 5,
        //     // image: image,
        //     'name': 'Hitansh Mehta',
        //     'description': 'PartTime Code Whisperer: Turning coffee into algorithms and bugs into features since yesterday.....',
        //     'instagram': 'https://www.instagram.com/_hitansh_m/',
        //     'linkedIn': 'www.linkedin.com/in/hitansh-m',
        //     'github': 'https://github.com/HitanshMehta',
        // },
        {
            'id': 6,
            image: riyaImg,
            'name': 'Riya Gala',
            'description': 'Juggling between building codes and doodling caricatures', 'instagram':
                'https://www.instagram.com/riyaa.gala/',
            'linkedIn': 'https://www.linkedin.com/in/riya-gala-96858b294',
            'github': '',
        },
        {
            'id': 7,
            image: jiteshImg,
            'name': 'Jitesh Guria ',
            'description': 'Empowering others and driving impactful change are at the core of my leadership philosophy.',
            'instagram': 'https://instagram.com/jitesh_g_?igshid=MzMyNGUyNmU2YQ%3D%3D&utm_source=qr',
            'linkedIn': 'https://www.linkedin.com/in/jitesh-guria-a1a587273?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
            'github': '',
        },

        {
            'id': 8,
            image: meenakshiImg,
            'name': 'Meenakshi Chandra ',
            'description': 'An optimistic person with loads of perseverance and holding strong ethical values, I relish bringing a professional touch to everything I do and at the same time remain grounded by being grateful always.',
            'instagram': 'https://instagram.com/meenakshi_sajith?igshid=YTQwZjQ0NmI0OA==',
            'linkedIn': 'https://www.linkedin.com/in/meenakshichandra',
            'github': 'nan',
        },
        {
            'id': 9,
            image: ridayImg,
            'name': 'Riday Gada',
            'description': 'I love exploring different things in life, writing is my passion and I like listening music.',
            'instagram': 'https://instagram.com/ridaygada_13?igshid=NzZlODBkYWE4Ng==',
            'linkedIn': 'https://www.linkedin.com/in/riday-gada-8589aa254?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app', 'github': 'nan',
        }
    ],
    app: [
        {
            'id': 0,
            image: vipulImg,
            'name': 'Vipul Gupta',
            'description': 'I like crafting visually engaging and user friendly interface for Android application.',
            'instagram': 'Not on insta',
            'linkedIn': 'https://www.linkedin.com/in/vipul-gupta-024682248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            'github': 'vipul12tpoly',
        },
        {
            'id': 1,
            image: sauravImg,
            'name': 'Saurav Haldar',
            'description': 'IT engineering student with a passion for app development, adept at crafting innovative digital solutions. Outside of coding, indulges in the artistry of pencil sketching, design, and editing for a well-rounded creative expression.',
            'instagram': 'https://www.instagram.com/sauravhaldar04/',
            'linkedIn': 'https://www.linkedin.com/in/saurav-haldar-6376b9274/',
            'github': 'https://github.com/SauravHaldar04',
        },
        {
            'id': 2,
            image: meetImg,
            'name': 'Meet Chavan',
            'description': '<Coding, gaming and tech enthusiast>',
            'instagram': 'https://www.instagram.com/_meetchavan_/',
            'linkedIn': 'https://www.linkedin.com/in/meet-chavan/', 'github':
                'https://github.com/meet242005/',
        },
        {
            'id': 3,
            image: varshaImg,
            'name': 'Varsha Islur',
            'description': 'I am an aspiring app developer and I’m driven by a passion for learning. I’m excited about the endless possibilities technology offers and the chance to connect with like-minded individuals who share my enthusiasm. I aim to contribute to meaningful projects that create positive change in the world.',
            'instagram': 'https://www.instagram.com/varsha_islur/',
            'linkedIn': 'http://www.linkedin.com/in/varsha-islur-818060291',
            'github': 'https://github.com/varshaislur/',
        },
        {
            'id': 4,
            image: ojasImg,
            'name': 'Ojas Geet ',
            'description': 'Tech enthusiast with a knack for turning error messages into punchlines.',
            'instagram': 'https://www.instagram.com/ojas_sg/',
            'linkedIn': 'https://www.linkedin.com/in/ojas-geet-807a5a295',
            'github': 'https://github.com/OjasGeet',
        }
    ],
}

export default cocomData;